export enum CumulDashboardViewMode {
  EDIT_FULL = "editFull", // Gives the access to create new dashboard from widget
  EDIT_LIMITED = "editLimited", // Doesn't give you an option to create new dashboard from widget
  VIEW = "view",
}
